import log from 'salvo-lite/log'
import { validate } from '../helpers/forms'

class MailingList {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('submit', e => {
            e.preventDefault()
            if (validate('email address', this._elem.querySelector('input'))) {
                // if (exponea) {
                window.exponea.identify({
                    email_id: '<< email value >>'.trim().toLowerCase()
                })

                window.exponea.update({
                    email: '<< email value >>'.trim().toLowerCase(),
                    unsubscribed: false
                })

                window.exponea.track('newsletter_signup', {
                    email: '<< email value >>'.trim().toLowerCase(),
                    form: '<< form identifier >>' /* optional, for example 'Footer Newsletter Subscription' */
                })
                // }
            } else {
                alert('Please enter a valid email address')
            }
        })
    }
}

export default MailingList



// WEBPACK FOOTER //
// ./src/resources/scripts/components/MailingList.js